"use client";

import { authorizedFetcherGet } from "@/utils/request";
import useSWR from "swr";
import { useAccessToken } from "./useAccessToken";

export type ReferralStatusResponse = {
  campaign_id: number;
  accepted: boolean;
  qualifying_quest_id: string | null;
};

export const useReferralStatus = (campaignId?: number) => {
  const getAccessToken = useAccessToken();

  const key = campaignId
    ? `/v1/quests/campaign/${campaignId}/referral-status`
    : null;

  const { data, error, isLoading, mutate } = useSWR(
    key,
    (path: string) =>
      authorizedFetcherGet<ReferralStatusResponse>(path, getAccessToken),
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    },
  );

  return { referralStatus: data, error, isLoading, mutate };
};
